import type { DashboardVariable } from "../../../../common/dashboard-spec";
import type { DashboardURLParamVariable } from "../../dashboard-variables-param";

export abstract class DashboardVariablesHelpers {
	public static toURLParams = (variables: ReadonlyArray<DashboardVariable>): DashboardURLParamVariable => {
		return variables
			.filter(({ spec }) => {
				const isNonConstantText = spec.kind === "TextVariable" && !spec.spec.constant;
				const isListWithDefault = spec.kind === "ListVariable" && spec.spec.defaultValue != null;

				return isNonConstantText || isListWithDefault;
			})
			.map(({ name, spec }) => {
				if (spec.kind === "TextVariable") {
					return { name, type: "Value", value: spec.spec.value };
				}

				// defaultValue cannot be undefined because of the filter
				const value = spec.spec.defaultValue!;

				if (value.type === "Everything") {
					return { name, type: "Everything" };
				}

				if (value.type === "Value") {
					return { name, type: "Value", value: value.value };
				}

				return { name, type: "Values", values: value.values };
			});
	};

	/**
	 * Applies each DashboardURLParamVariable to the DashboardVariable with the matching name
	 *
	 * @param values
	 * @param variables
	 * @returns A new array of variables with the URL values applied
	 */
	public static applyURLValuesToVariables = (
		values: DashboardURLParamVariable,
		variables: ReadonlyArray<DashboardVariable>,
	): Array<DashboardVariable> => {
		const nameToValue = new Map(values.map((value) => [value.name, value]));

		return variables.map((variable) => {
			const fullValue = nameToValue.get(variable.name);

			// Don't apply if there is no value or TextVariable is read-only/constant
			if (!fullValue || (variable.spec.kind === "TextVariable" && variable.spec.spec.constant)) {
				return variable;
			}

			const { name, ...value } = fullValue;

			return variable.updateValue(value);
		});
	};
}
